export class ReportVariationItem {
    text: string;
    value: any;
}
